import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import About from "../views/children/About.vue";
import Address from "../views/children/Address.vue";
import Case from "../views/children/Case.vue";
import Culture from "../views/children/Culture.vue";
import Baidu from "../views/children/Baidu.vue";
import Team from "../views/children/Team.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/abouts", name: "abouts", component: AboutView },
  { path: "/about", name: "About", meta: { title: "关于我们" }, component: About },
  { path: "/address", name: "Address", meta: { title: "联系我们" }, component: Address },
  { path: "/case", name: "Case", meta: { title: "项目案例" }, component: Case },
  { path: "/culture", name: "Culture", meta: { title: "企业文化" }, component: Culture },
  { path: "/bd", name: "BD", meta: { title: "百度百科" }, component: Baidu },
  { path: "/team", name: "Team", meta: { title: "团队介绍" }, component: Team },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
